import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
  background?: 'cream' | 'alt' | 'white' | 'teal';
}
export function Section({
  children,
  className = '',
  id,
  delay = 0,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FDFBF7]',
    alt: 'bg-[#F5F2EB]',
    white: 'bg-white',
    teal: 'bg-[#1A5F5A] text-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden ${bgColors[background]} ${className}`} data-id="element-139">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-140">
        {children}
      </motion.div>
    </section>;
}